import styled, { CSSProperties } from "styled-components";
import Autocomplete from "@mui/material/Autocomplete";
import { styled as MuiStyled } from "@mui/material/styles";

interface PropsWrapper {
  wrapperStyle?: CSSProperties;
}
export const Wrapper = styled.div<PropsWrapper>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 10px;
  margin-right: 10px;
  ${(props) =>
    props?.wrapperStyle &&
    Object.entries(props.wrapperStyle)
      .map(
        ([key, value]) =>
          `${key.replace(
            /[A-Z]/g,
            (match) => `-${match.toLowerCase()}`
          )}: ${value};`
      )
      .join("\n")}
`;
export const Text = styled.div``;
export const AddValueLabel = styled.div``;

export const TextFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  margin-bottom: 20px;
`;
export const TextInputLabel = styled.div`
  font-size: 18px;
  margin: 0px;
  margin-bottom: 5px;
  color: black;
  margin-top: 20px;
`;

export const SelectSearch = MuiStyled(Autocomplete)({
  "& .MuiAutocomplete-inputRoot": {
    padding: 0,
    paddingLeft: 10,
    paddingRight: 10,
    minWidth: 150,
    border: 4,
    borderColor: "#dedede",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#dedede",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fd954f",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fd954f",
      borderWidth: 2,
    },
  },
  "& .MuiAutocomplete-input": {
    fontSize: "16px",
  },
  "& .MuiAutocomplete-clearIndicator": {
    color: "#ff8038",
  },
});
